import { useTranslation } from 'react-i18next';
import NoData from '../../../components/NoData';
import ContentContainer from '../../../templates/Content/ContentContainer';

const Main = () => {
  const { t } = useTranslation();

  return (
    <ContentContainer title={t('superadmin')}>
      <NoData />
    </ContentContainer>
  );
};

export default Main;
